import React from 'react';
import introImg from '../../home.jpg';

const Orders = () => {
    return (
        <div>
            <img className='w-3/4 my-14 mx-auto' src={introImg} alt="" />
        </div>
    );
};

export default Orders;